var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 38,
    viewBox: "0 0 29 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8841 0C13.6694 0 9.44206 4.2533 9.44206 9.5V9.56333C14.6568 9.56333 18.8841 13.8166 18.8841 19.0633C18.8841 24.31 14.6569 28.5632 9.44227 28.5633C9.47612 33.7809 13.6904 38 18.8841 38C24.0988 38 28.3262 33.7467 28.3262 28.5V9.5C28.3262 4.2533 24.0988 0 18.8841 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76551 25.7809C4.53624 27.5624 6.93808 28.5633 9.44227 28.5633L9.44206 9.56333C6.93787 9.56333 4.53624 10.5642 2.76551 12.3458C0.994789 14.1274 0 16.5438 0 19.0633C0 21.5829 0.994781 23.9993 2.76551 25.7809Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/Mark.dbef2b415dd344e60c6c91e11914fa92.svg";
export { ForwardRef as ReactComponent };